export default __webpack_public_path__ + "static/media/Ballroll_00105.3e4f9527.png";